import axios from 'axios'

export default {

    fetch() {
        return new Promise((resolve, reject) => {
            axios({url: ('users'), method: 'GET'})
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    update(param) {
        return new Promise((resolve, reject) => {
            axios({url: 'users', data: param, method: 'POST'})
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    updateAvatar(param) {
        return new Promise((resolve, reject) => {
            axios({url: 'users/avatar/basic', data: param, method: 'POST'})
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    removeAvatar() {
        return new Promise((resolve, reject) => {
            axios({url: 'users/avatar', method: 'DELETE'})
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    updateNotifications(param) {
        return new Promise((resolve, reject) => {
            axios({url: 'users/consent', data: param, method: 'POST'})
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    verify() {
        return new Promise((resolve, reject) => {
            axios({url: 'users/verify', method: 'POST'})
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    changePassword(param) {
        return new Promise((resolve, reject) => {
            axios({url: 'users/password', data: param, method: 'POST'})
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
}
